import { render, staticRenderFns } from "./active-email.vue?vue&type=template&id=6281c7ce"
import script from "./active-email.vue?vue&type=script&lang=js"
export * from "./active-email.vue?vue&type=script&lang=js"
import style0 from "./active-email.vue?vue&type=style&index=0&id=6281c7ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports